import React, { useContext, useEffect, useState } from 'react'
import Header from '../../../global/Header'
import { Box, Button, CircularProgress, Typography } from '@mui/material'
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { AdminContext } from '../../../context/AdminContext';
import { tokens } from '../../../theme';
import UserDialog from '../UserDialog';
import { DataGrid } from '@mui/x-data-grid';
import { CheckCircle } from '@mui/icons-material';
import UserCouponBox from '../../CampaingsPage/CouponsPage/UserCouponBox';
import dayjs from 'dayjs';


function UserDetailsPage() {
    const { userId } = useParams();
    const { token } = useContext(AdminContext);
    const colors = tokens();
    const [user, setUser] = useState(null);
    const [scores, setScores] = useState(null);
    const [revenuecatData, setRevenuecatData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [userDialogOpen, setUserDialogOpen] = useState(false);



    const [logs, setLogs] = useState([]);
    const [isLogsLoading, setLogsLoading] = useState(true);
    const [logsOrderModel, setLogsOrderModel] = useState(null);
    const [logsRowCount, setLogsRowCount] = useState(0);
    const [logsPaginationModel, setLogsPaginationModel] = useState({
        page: 0,
        pageSize: 10
    });


    const fetchUser = () => {
        axios.get(`${process.env.REACT_APP_API_URL}user/getUserViaId?id=${userId}`)
            .catch((err) => {
                console.log("err: " + err);
                setUser(null);
                setLoading(false);
            })
            .then((response) => {
                if (response && response.data.success === true && response.data.status === 200) {
                    setUser(response.data.user);
                    setLoading(false);
                }
            });
    };

    const fetUserScores = () => {
        axios.get(`${process.env.REACT_APP_API_URL}user/getUsersAllScores?id=${userId}`)
            .catch((err) => {
                console.log("err: " + err);
                setScores(null);
            })
            .then((response) => {
                if (response && response.data.success === true && response.data.status === 200) {
                    setScores(response.data.scores);
                }
            });
    };

    const fetchLogs = () => {
        setLogsLoading(true);
        axios.get(`${process.env.REACT_APP_API_URL}user/getUserLogs?userId=${userId}&startIndex=${logsPaginationModel.pageSize * logsPaginationModel.page}&limit=${logsPaginationModel.pageSize}${logsOrderModel ? `&orderColumn=${logsOrderModel.field}&orderType=${logsOrderModel.sort}` : ""}&token=${token}`)
            .catch((err) => {
                setLogs([]);
                console.log("err: " + err);
            })
            .then((response) => {
                if (response && response.data.success === true && response.data.status === 200) {
                    setLogs(response.data.logs);
                    setLogsRowCount((prevRowCount) => response.data.rowCount !== undefined ? response.data.rowCount : prevRowCount);
                }
                setLogsLoading(false);
            });
    };

    const fetchPremiumData = () => {
        axios.get(`https://api.revenuecat.com/v1/subscribers/${userId}`, {
            headers: {
                "Authorization": `Bearer sk_jUgQLvWJQdPDqDcyluZOQlMTUEJhB`,
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        })
            .catch((err) => {
                console.log("err: " + err);
            })
            .then((response) => {
                console.log("response: ", response);
                if (response && response.data && response.data.subscriber.subscriptions) {
                    let lastActiveSubscription = null;

                    for (const subscription in response.data.subscriber.subscriptions) {
                        if (response.data.subscriber.subscriptions[subscription].expires_date) {
                            if (dayjs(response.data.subscriber.subscriptions[subscription].expires_date).isAfter(dayjs())) {
                                lastActiveSubscription = response.data.subscriber.subscriptions[subscription];
                                break;
                            }
                        }
                    }

                    console.log("lastActiveSubscription: ", lastActiveSubscription);

                    if (lastActiveSubscription) {
                        setRevenuecatData({
                            subscriptionStartDate: dayjs(lastActiveSubscription.purchase_date).format("DD.MM.YYYY HH:mm:ss"),
                            subscriptionEndDate: dayjs(lastActiveSubscription.expires_date).format("DD.MM.YYYY HH:mm:ss"),
                            purchased: lastActiveSubscription.store === "promotional" ? false : true,
                            autoRenewal: (lastActiveSubscription.store !== "promotional" && lastActiveSubscription.unsubscribe_detected_at === null)
                        });
                    }

                }
            });
    };


    useEffect(() => {
        fetchUser();
        fetUserScores();
    }, []);

    useEffect(() => {
        if (user && user.is_premium) {
            fetchPremiumData();
        }
    }, [user]);

    useEffect(() => {
        fetchLogs();
    }, [logsPaginationModel, logsOrderModel]);


    const updateUser = async (user) => {

        if (user.photo) {
            await axios.post(`${process.env.REACT_APP_API_URL}user/uploadProfilePhoto`, {
                profilePhoto: user.photo
            }, {
                headers: {
                    "content-type": "multipart/form-data"
                }
            })
                .catch((err) => {
                    console.log("err: " + err);
                })
                .then((response) => {
                    if (response && response.data.success === true && response.data.status === 201) {
                        delete user.photo;
                        delete user.profile_photo_link;
                        user.profile_photo_path = response.data.photoPath;
                    }
                });
        }



        var userToUpdate = { ...user };
        delete userToUpdate.photo;
        delete userToUpdate.profile_photo_link;

        await axios.patch(`${process.env.REACT_APP_API_URL}user/updateUser?userId=${userId}`, {
            user: userToUpdate
        })
            .catch((err) => {
                console.log("err: " + err);
            })
            .then(async (response) => {
                if (response && response.data.success === true && response.data.isUpdated === true && response.data.status === 201) {
                    if (userToUpdate.gold === user.gold) {
                        setUser(prev => ({ ...prev, ...userToUpdate }));
                    } else {
                        await axios.post(`${process.env.REACT_APP_API_URL}user/createLog`, {
                            action: userToUpdate.gold > user.gold ? "add_gold_by_admin" : "decrease_gold_by_admin",
                            user_id: userId,
                            amount: Math.abs(userToUpdate.gold - user.gold),
                        })
                            .catch((err) => {
                                console.log("err: " + err);
                                setUser(prev => ({ ...prev, ...userToUpdate }));
                            })
                            .then(() => {
                                setUser(prev => ({ ...prev, ...userToUpdate }));
                            });
                    }
                    if (userDialogOpen) {
                        setUserDialogOpen(false);
                    }
                }
            });
    }


    if (loading && !user) {
        return (
            <Box sx={{ p: "75px", display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <CircularProgress color="primary" />
            </Box>
        )
    }


    return (
        <Box sx={{ p: "75px" }}>
            <UserDialog dialogOpen={userDialogOpen} handleClose={() => setUserDialogOpen(false)} targetUser={user} handleFormSubmit={(values) => updateUser(values)} />

            <Box display="flex" alignItems="center" gap="20px">
                <Header title={user?.name} subtitle="" />
                <Button variant='contained' color='success' sx={{ mb: "30px", width: '25ch' }} onClick={() => {
                    setUserDialogOpen(true);
                }} >
                    Edit User
                </Button>
            </Box>

            <Typography variant='h5' color="primary">
                {user?.bio}
            </Typography>

            {!!user &&
                <Box
                    display="flex"
                    alignItems="center"
                    gap="20px"
                    mt="20px"
                    flexWrap={"wrap"}
                >
                    {
                        <InfoBox>
                            User ID: {user.id}
                        </InfoBox>
                    }
                    {
                        !!user.mail &&
                        <InfoBox>
                            {user.mail}
                        </InfoBox>
                    }
                    {
                        !!user.phone_number &&
                        <InfoBox>
                            {user.phone_number}
                        </InfoBox>
                    }

                    <InfoBox>
                        <img
                            src={"/assets/gold.png"}
                            alt='gold'
                            width="21px"
                            height="21px"
                            style={{
                                objectFit: "cover",
                            }}
                        />
                        <span>
                            Gold:
                        </span>
                        <span style={{ fontWeight: "bold" }}>
                            {user.gold}
                        </span>
                    </InfoBox>

                    <InfoBox>
                        <img
                            src={"/assets/heart.png"}
                            alt='heart'
                            width="21px"
                            height="21px"
                            style={{
                                objectFit: "cover",
                            }}
                        />
                        <span>
                            Heart:
                        </span>
                        <span style={{ fontWeight: "bold" }}>
                            {user.heart_count}
                        </span>
                    </InfoBox>

                    <InfoBox>
                        <img
                            src={"/assets/fire.png"}
                            alt='fire'
                            width="21px"
                            height="21px"
                            style={{
                                objectFit: "cover",
                            }}
                        />
                        <span>
                            Current Streak:
                        </span>
                        <span style={{ fontWeight: "bold" }}>
                            {user.loyalty_count}
                        </span>
                    </InfoBox>

                    <InfoBox>
                        <img
                            src={"/assets/fire.png"}
                            alt='fire'
                            width="21px"
                            height="21px"
                            style={{
                                objectFit: "cover",
                            }}
                        />
                        <span>
                            Max Streak:
                        </span>
                        <span style={{ fontWeight: "bold" }}>
                            {user.max_loyalty_count}
                        </span>
                    </InfoBox>

                    <InfoBox>
                        <img
                            src={"/assets/joker_pass.png"}
                            alt='joker_pass'
                            width="21px"
                            height="21px"
                            style={{
                                objectFit: "cover",
                            }}
                        />
                        <span>
                            Pass Joker:
                        </span>
                        <span style={{ fontWeight: "bold" }}>
                            {user.joker_pass_count}
                        </span>
                    </InfoBox>

                    <InfoBox>
                        <img
                            src={"/assets/joker_fifty.png"}
                            alt='joker_fifty'
                            width="21px"
                            height="21px"
                            style={{
                                objectFit: "cover",
                            }}
                        />
                        <span>
                            Fifty-Fifty Joker:
                        </span>
                        <span style={{ fontWeight: "bold" }}>
                            {user.joker_fifty_count}
                        </span>
                    </InfoBox>

                    <InfoBox>
                        <img
                            src={"/assets/joker_double.png"}
                            alt='joker_double'
                            width="21px"
                            height="21px"
                            style={{
                                objectFit: "cover",
                            }}
                        />
                        <span>
                            Double Answer Joker:
                        </span>
                        <span style={{ fontWeight: "bold" }}>
                            {user.joker_double_count}
                        </span>
                    </InfoBox>

                    <InfoBox>
                        <img
                            src={"/assets/joker_time.png"}
                            alt='joker_time'
                            width="21px"
                            height="21px"
                            style={{
                                objectFit: "cover",
                            }}
                        />
                        <span>
                            Extra Time Joker:
                        </span>
                        <span style={{ fontWeight: "bold" }}>
                            {user.joker_time_count}
                        </span>
                    </InfoBox>

                    <InfoBox>
                        Premium: {
                            !!(user.is_premium) ?
                                "✔️" : "❌"
                        }
                    </InfoBox>
                    {!!(user.is_premium && revenuecatData) &&
                        <>
                            <InfoBox>
                                Purchased: {
                                    !!(revenuecatData.purchased) ?
                                        "✔️" : "❌"
                                }
                            </InfoBox>
                            <InfoBox>
                                Subscribed At: {revenuecatData.subscriptionStartDate}
                            </InfoBox>
                            <InfoBox>
                                Expires At: {revenuecatData.subscriptionEndDate}
                            </InfoBox>
                            <InfoBox>
                                Auto Renewal: {
                                    !!(revenuecatData.autoRenewal) ?
                                        "✔️" : "❌"
                                }
                            </InfoBox>
                        </>
                    }
                    
                    {!!(scores) && (
                        <>
                            {!!(scores.daily_score_board_info?.user_rank) &&
                                <InfoBox>
                                    Daily Rank: <span style={{ fontWeight: "bold" }}>{scores.daily_score_board_info?.user_rank}</span>
                                </InfoBox>
                            }
                            {!!(scores.weekly_score_board_info?.user_rank) &&
                                <InfoBox>
                                    Weekly Rank: <span style={{ fontWeight: "bold" }}>{scores.weekly_score_board_info?.user_rank}</span>
                                </InfoBox>
                            }
                            {!!(scores.monthly_score_board_info?.user_rank) &&
                                <InfoBox>
                                    Monthly Rank: <span style={{ fontWeight: "bold" }}>{scores.monthly_score_board_info?.user_rank}</span>
                                </InfoBox>
                            }
                            {!!(scores.total_score_board_info?.user_rank) &&
                                <InfoBox>
                                    Total Rank: <span style={{ fontWeight: "bold" }}>{scores.total_score_board_info?.user_rank}</span>
                                </InfoBox>
                            }
                        </>
                    )
                    }
                </Box>
            }

            <Box mt="40px">
                <Box >
                    <Box sx={{ p: 1, border: "1px solid", borderColor: "grey.300", borderRadius: "5px", maxHeight: "300px", ...(user?.courses?.length > 0 ? { minHeight: "300px" } : {}), overflowY: "scroll" }}>
                        <Box display="flex" alignItems="center" gap="10px">
                            <Typography variant="h6" color="primary" fontWeight="bold">
                                Enrolled Courses
                            </Typography>
                        </Box>
                        <Box mt="30px">
                            {
                                user?.courses?.length > 0 ?
                                    <Box display="flex" flexWrap={"wrap"} gap={"10px"}>
                                        {user?.courses?.map((course, index) => (
                                            //thumbnail, title, completed_date
                                            <Box key={index} display="flex" alignItems="center" justifyContent="space-between" sx={{ p: 1, border: "1px solid", borderColor: "grey.500", borderRadius: "5px", mt: "10px", maxWidth: "400px", minWidth: "400px" }}>
                                                <Box display="flex" gap="10px">
                                                    <img src={course.thumbnail_link} alt={course.title} width="130px" height="150px" style={{
                                                        objectFit: "cover",
                                                    }} />
                                                    <Box display="flex" flexDirection="column" gap="10px">
                                                        <Typography variant="h3" color="primary">
                                                            {course.title}
                                                        </Typography>
                                                        <Typography variant="body1" color="primary">
                                                            Enrolled Date:<br />
                                                            {new Date(course.enrolled_date).toLocaleString()}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                    :
                                    <Typography variant="body1" color="primary">
                                        User has not enrolled any course yet.
                                    </Typography>
                            }
                        </Box>
                    </Box>
                </Box>
                <Box mt="20px" >
                    <Box sx={{ p: 1, border: "1px solid", borderColor: "grey.300", borderRadius: "5px", maxHeight: "300px", ...(user?.readings?.length > 0 ? { minHeight: "300px" } : {}), overflowY: "scroll" }}>
                        <Box display="flex" alignItems="center" gap="10px">
                            <Typography variant="h6" color="primary" fontWeight="bold">
                                Completed Readings
                            </Typography>
                        </Box>
                        <Box mt="30px">
                            {
                                user?.readings?.length > 0 ?
                                    <Box display="flex" flexWrap={"wrap"} gap={"10px"}>
                                        {
                                            user?.readings?.map((reading, index) => (
                                                //thumbnail, title, completed_date, status(1 yellow tick, 2 green tick)
                                                <Box key={index} position="relative" display="flex" alignItems="center" justifyContent="space-between" sx={{ p: 1, border: "1px solid", borderColor: "grey.500", borderRadius: "5px", mt: "10px", maxWidth: "400px", minWidth: "400px" }}>
                                                    <Box display="flex" gap="10px">
                                                        <img src={reading.thumbnail_link} alt={reading.title} width="130px" height="150px" style={{
                                                            objectFit: "cover",
                                                        }} />
                                                        <Box display="flex" flexDirection="column" gap="10px">
                                                            <Typography variant="h3" color="primary">
                                                                {reading.title}
                                                            </Typography>
                                                            <Typography variant="body1" color="primary">
                                                                Completed Date:<br />
                                                                {new Date(reading.completed_date).toLocaleString()}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box position="absolute" bottom="0" right="0" sx={{ mr: "10px" }}>
                                                        <CheckCircle sx={{ color: reading.status === 1 ? "#ffbc00" : "#2d8000", fontSize: '30px' }} />
                                                    </Box>
                                                </Box>
                                            ))
                                        }
                                    </Box>
                                    :
                                    <Typography variant="body1" color="primary">
                                        User has not completed any reading yet.
                                    </Typography>
                            }
                        </Box>
                    </Box>
                </Box>
                <Box mt="20px" >
                    <Box sx={{ p: 1, border: "1px solid", borderColor: "grey.300", borderRadius: "5px", maxHeight: "300px", ...(user?.coupons?.length > 0 ? { minHeight: "300px" } : {}), overflowY: "scroll" }}>
                        <Box display="flex" alignItems="center" gap="10px">
                            <Typography variant="h6" color="primary" fontWeight="bold">
                                Used Coupons
                            </Typography>
                        </Box>
                        <Box>
                            {
                                user?.coupons?.length > 0 ?
                                    <Box display="flex" flexWrap={"wrap"} gap={"10px"}>
                                        {
                                            user?.coupons?.map((coupon, index) => (
                                                <UserCouponBox key={coupon.id} coupon={coupon} />
                                            ))
                                        }
                                    </Box>
                                    :
                                    <Typography variant="body1" color="primary" mt="30px">
                                        User has not used any coupon yet.
                                    </Typography>
                            }
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Box mt="40px">
                <Typography variant="h5" color="primary" fontWeight="bold">
                    Logs
                </Typography>
                {
                    logs?.length > 0 ?
                        <Box mt="20px">
                            <DataGrid
                                rows={logs}
                                columns={[
                                    { field: 'id', headerName: 'ID', width: 90 },
                                    {
                                        field: 'action', headerName: 'action', width: 300,
                                        renderCell: (params) => (
                                            <Typography variant="body1" color="primary">
                                                {
                                                    params.row.action === "login" && "User logged in."
                                                }
                                                {
                                                    params.row.action === "reading_read" && `User completed a reading without quiz(${params.row.reading_title}).`
                                                }
                                                {
                                                    params.row.action === "reading_quiz_done" && `User completed a reading quiz(${params.row.reading_title}).`
                                                }
                                                {
                                                    params.row.action === "course_enroll" && `User enrolled a course(${params.row.course_title}).`
                                                }
                                                {
                                                    params.row.action === "course_saved" && `User saved a course(${params.row.course_title}).`
                                                }
                                                {
                                                    params.row.action === "course_unsaved" && `User unsaved a course(${params.row.course_title}).`
                                                }
                                                {
                                                    params.row.action === "course_rate" && `User rated a course(${params.row.course_title}).`
                                                }
                                                {
                                                    params.row.action === "coupon_used" && `User used a coupon(${params.row.coupon_title}).`
                                                }
                                                {
                                                    params.row.action === "gold_earning_from_scoreboard" && `User earned ${params.row.amount} gold from scoreboard.`
                                                }
                                                {
                                                    params.row.action === "gold_earning_from_daily_login" && `User earned ${params.row.amount} gold from daily login.`
                                                }
                                                {
                                                    params.row.action === "gold_earning_from_watching_ad" && `User earned ${params.row.amount} gold from watching ad.`
                                                }
                                                {
                                                    params.row.action === "add_gold_by_admin" && `Admin added ${params.row.amount} gold to user.`
                                                }


                                                {
                                                    params.row.action === "gold_spending_for_joker" && `User spent ${params.row.amount} gold to buy joker.`
                                                }
                                                {
                                                    params.row.action === "gold_spending_for_2x_score" && `User spent ${params.row.amount} gold to double the points earned.`
                                                }
                                                {
                                                    params.row.action === "gold_spending_for_heart" && `User spent ${params.row.amount} gold to buy heart.`
                                                }
                                                {
                                                    params.row.action === "decrease_gold_by_admin" && `User spent ${params.row.amount} gold to buy premium.`
                                                }

                                                {
                                                    params.row.action === "standart_quiz_done" && `User completed a standart quiz. Score: ${params.row.amount}.`
                                                }
                                                {
                                                    params.row.action === "word_quiz_done" && `User completed a word quiz. Score: ${params.row.amount}.`
                                                }

                                                {
                                                    params.row.action === "created_word_set" && `User created a word set(${params.row.word_set_name}).`
                                                }
                                                {
                                                    params.row.action === "studied_word_set" && `User studied a word set(${params.row.word_set_name}).`
                                                }
                                                {
                                                    params.row.action === "buy_gold" && `User bought ${params.row.amount} gold.`
                                                }
                                                {
                                                    params.row.action === "buy_premium" && "User bought premium."
                                                }
                                                {
                                                    params.row.action === "buy_heart" && "User bought heart."
                                                }
                                                {
                                                    params.row.action === "heart_earning_from_watching_ad" && "User earned heart from watching ad."
                                                }
                                                {
                                                    params.row.action === "follow" && `User followed ${params.row.target_user_name}.`
                                                }
                                                {
                                                    params.row.action === "unfollow" && `User unfollowed ${params.row.target_user_name}.`
                                                }
                                            </Typography>
                                        ),
                                    },
                                    {
                                        field: 'created_date', headerName: 'Created Date', width: 200,
                                        renderCell: (params) => (
                                            <Typography variant="body1" color="primary">
                                                {new Date(params.row.created_date).toLocaleString()}
                                            </Typography>
                                        ),
                                    },
                                ]}
                                rowCount={logsRowCount}
                                loading={isLogsLoading}
                                pageSizeOptions={[10, 25, 50, 75, 100]}
                                paginationModel={logsPaginationModel}
                                paginationMode="server"
                                onPaginationModelChange={setLogsPaginationModel}
                                sortingMode='server'
                                onSortModelChange={(model) => {
                                    setLogsOrderModel((prev) => model && model.length > 0 ? model[0] : null);
                                    setLogsPaginationModel(prev => { return { ...prev, page: 0 } });
                                }}
                                disableColumnFilter
                                sx={{
                                    ".MuiDataGrid-columnHeaders": {
                                        background: colors.grey[900]
                                    }
                                }}
                            />
                        </Box>
                        :
                        < Box mt="20px">
                            <Typography variant="body1" color="primary">
                                There are no logs for this user yet.
                            </Typography>
                        </Box>
                }
            </Box>
        </Box >
    )
}

function InfoBox({ children }) {
    const colors = tokens();
    return (
        <Box sx={{
            background: colors.grey[900],
            padding: "10px",
            borderRadius: "5px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
        }}>
            {children}
        </Box>
    )
}

export default UserDetailsPage